export default "__VITE_ASSET__C6oRkyJ7__"